module.exports = __webpack_public_path__ + "static/media/scroll.dfbf0ff7.webp";